var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 2.33346L13.6667 5.66679L14.7239 4.6096C15.2446 4.0889 15.2446 3.24468 14.7239 2.72398L13.2762 1.27627C12.7555 0.755567 11.9113 0.755568 11.3906 1.27627L10.3334 2.33346Z",
    fill: "#101D3B",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33337 14.6668V11.3335L9.66671 3.00012L13 6.33346L4.66671 14.6668H1.33337ZM2.66671 13.3335V11.8857L9.66671 4.88574L11.1144 6.33346L4.11442 13.3335H2.66671Z",
    fill: "#101D3B",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d030cfe8c938b8000a34ff629dede8c4.svg";
export { ForwardRef as ReactComponent };